import { useEffect, useState } from "react";
import { api } from "./api";

export type OptionGroup = "recipients" | "vibes" | "occasions";
export type DisabledOptions = Record<OptionGroup, string[]>;
export interface SiteSettings { default_occasion: string; theme: "none" | "christmas"; disabled_options: DisabledOptions }

let cache: SiteSettings | null = null;
let pending: Promise<SiteSettings> | null = null;
const listeners = new Set<(s: SiteSettings) => void>();

const load = () => {
  pending = pending || api.get<SiteSettings>("/settings").then((r) => (cache = r.data)).catch((e) => { pending = null; throw e; });
  return pending;
};

export const setSiteSettingsCache = (s: SiteSettings) => { cache = s; listeners.forEach((l) => l(s)); };

export function useSiteSettings() {
  const [s, setS] = useState<SiteSettings | null>(cache);
  useEffect(() => {
    listeners.add(setS);
    if (!cache) load().then(setS).catch(() => undefined);
    return () => { listeners.delete(setS); };
  }, []);
  return s;
}

export const enabledOnly = <T extends { id: string }>(list: T[], s: SiteSettings | null, group: OptionGroup) => {
  const off = s?.disabled_options?.[group] || [];
  return list.filter((o) => !off.includes(o.id));
};
